module.exports = __webpack_public_path__ + "static/media/Hero_Image_Mobile_4.978caab5.jpg";